import { ACTION_TYPE } from '../core/redux/actionType';
import { IAppState } from '../core/redux/IAppState';
import { Action } from 'redux';
import {assoc} from '../language/module';
import { removeLoadingAndError } from '../core/redux/api/module';
import { clearBreaker } from '../core/redux/api/circuitBreaker/module';


const RESORT_SCOPED_ACTIONS = [
  ACTION_TYPE.RESORT_MAPPING_REQUEST,
  ACTION_TYPE.RESORT_MAPPING_ERROR_REQUEST,
  ACTION_TYPE.RESORT_MAPPING_HAS_ERROR_REQUEST,
  ACTION_TYPE.PRODUCT_HYDRATION_ERRORS_REQUEST,
];


type ClearResortMappingAction = {
  type: ACTION_TYPE.CLEAR_RESORT_MAPPING_ACTION
};

export const KEY_ACTION = ACTION_TYPE.CLEAR_RESORT_MAPPING_ACTION;

/**
 * Makes an action that can be dispatched to set the resortMappingHistories to default values on selected resort change
 * @param payload
 */
export const clearResortMappingAction = (): ClearResortMappingAction => ({
  type: ACTION_TYPE.CLEAR_RESORT_MAPPING_ACTION,
});

export const clearResortMappingReducer = (state: IAppState, action: Action): IAppState => {

  if (action.type !== ACTION_TYPE.CLEAR_RESORT_MAPPING_ACTION) return state;

  const noLoadingOrError = removeLoadingAndError(state, KEY_ACTION, KEY_ACTION);

  // Breakers are keyed by action type, not by resort, so a resort that fails these calls would otherwise
  // keep suppressing them on the next resort — silently, since a bailout raises nothing
  const noBreakers = RESORT_SCOPED_ACTIONS.reduce(clearBreaker, noLoadingOrError);

  // The page reads a stored failure as that load's status, so none may outlive the switch, whichever resort it names
  const noScopedErrors = assoc(
    'error',
    noBreakers.error.filter((key, error) => !RESORT_SCOPED_ACTIONS.includes(error.actionType as ACTION_TYPE)),
    noBreakers,
  );

  // This reducer blanks the rows below, so it blanks what says those rows were loaded along with them.
  // Whoever else comes to switch resorts has to dispatch this too, or the two disagree.
  const noRequestedFor = assoc('mappingErrorsRequestedFor', '',
    assoc('mappingErrorsLoadedFor', '',
      assoc('mappingErrorsLoadedAt', undefined,
        assoc('mappingsLoadedFor', '',
          assoc('productHydrationErrorsLoadedFor', '', noScopedErrors)))));

  // Rows of the resort switched to would otherwise pick these up until its own load lands
  const noHydrationErrors = assoc('productHydrationErrors', [], noRequestedFor);

  const clearResortMappingHasError = assoc('resortMappingHasError', false, noHydrationErrors);

  return assoc('resortMappingHistories', 
    {
      posProvider: 'string',
      productMappings: [],
      hasError: false
    }
    , clearResortMappingHasError);
}
